// src/pages/Home.jsx
import React, { useContext } from 'react';
import { Typography, Box } from '@mui/material';
import { UserContext } from '../contexts/UserContext';
import DeckOverview from '../components/DeckOverview';
import CampaignPanel from '../components/CampaignPanel';
import DailyRewards from '../components/DailyRewards';
import Notifications from '../components/Notifications';

function Home() {
  const { userData } = useContext(UserContext);

  if (!userData ) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1,
        }}
      >
        <Box>
          <Typography variant="h4" gutterBottom>
            Welcome, {userData.username}
          </Typography>
          <Typography gutterBottom>
            Prepare your deck and become a legend
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <DailyRewards />
          <Notifications />
        </Box>
      </Box>

      <Box sx={{ mt: 3 }}>
        <DeckOverview showActive={true} showDefense={false} />
        <CampaignPanel />
      </Box>
    </>
  );
}

export default Home;
